import React from 'react'
import { Outlet } from 'react-router-dom'
import { useNavigate, useLocation, Navigate } from 'react-router-dom'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import cn from 'classnames'


const TABS = [
  { name: 'Логи', path: '/dashboard/logs' },
  { name: 'Сервера', path: '/dashboard/servers' }
]

const Main = () => {
  
  const navigate = useNavigate()
  const {pathname} = useLocation()

  const {loading} = useSelector(state => state.dashboard)

  const renderTab = ({name, path}) => {
     
    const classNames = cn({
      [styles.active]: path === pathname,
      [styles.disabled]: loading
    })
    
    return (
      <li
        onClick={() => navigate(path, {replace: true})}
        className={classNames}
      >
        {name}
      </li>
    )
  }

  if (pathname === '/dashboard') return <Navigate to='/dashboard/logs' replace/>;

  return (
    <div className={styles.wrapper}>
      <nav>
        <ul>
          {TABS.map(renderTab)}
        </ul>
      </nav>
      <Outlet/>
    </div>
  )
}

export default Main